<template>
  <div>
    <div>
      <p class="title">预约信息</p>
      <table class="c-talbe">
        <tr>
          <td class="text-right" width="150">预约日期</td>
          <td v-if="appoint">{{ appoint.appointDate }}</td>
        </tr>
        <tr>
          <td class="text-right" width="150">预约时间</td>
          <td v-if="appoint">{{ appoint.startTime }}-{{ appoint.endTime }}</td>
        </tr>
        <tr>
          <td class="text-right">预约地点</td>
          <td v-if="appoint">{{ appoint.pavilionPlace }}</td>
        </tr>
        <tr>
          <td class="text-right">面试亭</td>
          <td v-if="appoint">{{ appoint.pavilionName }}</td>
        </tr>
        <tr>
          <td class="text-right"/>
          <td v-if="appoint">
            <el-avatar
              shape="square"
              :size="90"
              :src="appoint.imgUrl"
            />
          </td>
        </tr>
      </table>
    </div>
    <div>
      <p class="title">密码信息</p>
      <table class="c-talbe">
        <tr>
          <td class="text-right" width="150">密码</td>
          <td v-if="appoint">{{ isShowKey(appoint) ? `${appoint.secretKey.openPwd}#` : '空' }}</td>
        </tr>
        <tr>
          <td class="text-right" width="150">二维码</td>
          <td v-if="appoint && isShowKey(appoint)" @click="appointQRDialog = true">
            <qrcode-vue :value="appoint.secretKey.qrPwd" :size="windowInnerWidth * 0.45"/>
          </td>
          <td v-else>
            空
          </td>
        </tr>
      </table>
    </div>
    <el-dialog
      v-if="appoint && isShowKey(appoint)"
      :visible.sync="appointQRDialog"
      width="100%"
      :fullscreen="fullscreen"
      center>
      <div style="text-align: center;">
        <h1 class="qr_dialog">开门二维码</h1>
        <qrcode-vue :value="appoint.secretKey.qrPwd" :size="windowInnerWidth * 0.7"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import QrcodeVue from "qrcode.vue";
import {isShowKey} from "../assets/js/pavilion";

export default {
  methods: {isShowKey},
  components: {QrcodeVue},
  props: {
    appoint: {},
  },
  data() {
    return {
      fullscreen: true,
      appointQRDialog: false,
      windowInnerWidth: 0
    }
  },
  created() {
    this.windowInnerWidth = window.innerWidth
  }
};
</script>
<style scoped>
.title {
  width: 100%;
  padding: 10px;
  background-color: rgb(198, 212, 248);
  text-align: center;
  font-weight: bold;
  margin: 10px 0;
}

.c-talbe {
  display: table-cell;
  width: 100%;
}

.c-talbe td {
  padding: 5px;
}

p {
  line-height: 24px;
}

tr td:nth-child(2) {
  font-weight: bolder;
}

.qr_dialog {
  font-size: 30px;
  color: #3D95C9;
  font-weight: bolder;
  margin-bottom: 50px;
}
</style>
